const SERVICES = [
  {
    eyebrow: "01",
    title: "AWS architecture & migration",
    body:
      "Cloud-native architecture, lift-and-shift migrations, and the hardening " +
      "every production system needs before real traffic. Delivered by " +
      "AWS-certified engineers who've actually run this in anger.",
  },
  {
    eyebrow: "02",
    title: "AI integration for business",
    body:
      "Practical AI embedded in the workflows your team already runs. " +
      "Evaluations, guardrails, and the infrastructure that makes " +
      "model-backed features safe to ship.",
  },
  {
    eyebrow: "03",
    title: "Custom application development",
    body:
      "Web and serverless apps built on AWS. Idiomatic infrastructure, " +
      "observable systems, and sensible budgets. Most clients keep us " +
      "operating the result; full handoff to your team is available when " +
      "that's the preference.",
  },
  {
    eyebrow: "04",
    title: "Domain partnerships",
    body:
      "We pair with business and domain experts to ship solutions to specific " +
      "industries. You bring the operational knowledge; we bring the cloud " +
      "and the engineering. When a build is positioned to become a product, " +
      "partners can hold a stake in the result.",
  },
];

export default function Services() {
  return (
    <section className="section" id="services">
      <div className="container">
        <header className="section-header">
          <p className="section-eyebrow">What we do</p>
          <h2 className="section-title">Cloud, AI, and the engineering to ship them.</h2>
          <p className="section-lede">
            A small senior team that codes, ships, and owns the work end to end.
          </p>
        </header>
        <div className="card-grid">
          {SERVICES.map((s) => (
            <article key={s.title} className="card">
              <p className="card-eyebrow">{s.eyebrow}</p>
              <h3 className="card-title">{s.title}</h3>
              <p className="card-body">{s.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
